<template>
  <div class="allBox">
    <div class="headerBox" v-if="headerShow">
      <slot name="header">
        <Navbar 
          :title="title" 
          :topBj="topBj" 
          :topColor="topColor"
          :leftShow="leftShow"
          :backUrl="backUrl"
        />
      </slot>
    </div>
    <div class="contentBox" 
      :style="{
        backgroundColor: contentBj,
        top: headerShow ? '1.2rem' : '0',
        bottom: footerShow ? '1.6rem' : '0'
      }"
      > 
      <slot></slot>
    </div>
    <div class="footerBox" v-if="footerShow"> 
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否展示顶部
    headerShow: {
      type: Boolean,
      default: true,
    },
    // 头部标题
    title: {
      type: String,
      default: '',
    },
    // 头部左边文案
    leftText: {
      type: String,
      default: '返回',
    },
    // 是否展示左边返回按钮
    leftShow: { 
      type: Boolean,
      default: true,
    },
    // 头部背景色
    topBj: {
      type: String,
      default: '#ff0000',
    },
    topColor: {
      type: String,
      default: '#fff',
    },
    // 头部右边文案
    rightText: {
      type: String,
      default: '',
    }, 
    // 返回链接
    backUrl: { 
      type: String,
      default: '',
    },

    // 内容背景色
    contentBj: { 
      type: String,
      default: '#fff',
    },

    // 是否展示底部
    footerShow: {
      type: Boolean,
      default: false,
    },
  },
  data() { 
    return { 

    }
  },
}
</script>

<style lang="less">
.allBox { 
  .contentBox { 
    position: absolute;
    width: 100%;
    // height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: calc(100% - var(--safe-area-inset-top) - var(--safe-area-inset-bottom));
    /* 顶部和底部内边距 */
    padding-top: var(--safe-area-inset-top);
    padding-bottom: var(--safe-area-inset-bottom);
    box-sizing: border-box; /* 防止padding撑大容器 */
    overflow-y: auto;
  }
  .footerBox {  
    position: fixed;
    width:100%;
    height: 1.6rem;
    bottom: 0;
  }
}
</style>